// extracted by mini-css-extract-plugin
export var bounce = "_mx-1";
export var generatingText = "_mx-6";
export var lightning = "_mx-4";
export var popup = "_mx-5";
export var progressBar = "_mx-7";
export var progressFill = "_mx-8";
export var progressShimmer = "_mx-9";
export var progressText = "_mx-a";
export var shimmer = "_mx-3";
export var uploadIcon = "_mx-0";
export var uploadingText = "_mx-2";